<!--
@Time : 2020/11/28 7:27 下午
@Author : yekong
@File : yujing.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="yujing">
      <titles title="预警列表"></titles>
      <div class="title1">
        <span>政务服务</span>
      </div>
      <div class="list">
        <div class="item">
          <p>网上政务服务能力</p>
          <span>异常</span>
        </div>
        <div class="item">
          <p>政务服务事项便利度</p>
          <span>异常</span>
        </div>
        <div class="item">
          <p>政务服务满意度</p>
          <span>异常</span>
        </div>
      </div>
      <div class="title1">
        <span>信用建设</span>
      </div>
      <div class="list">
        <div class="item">
          <p>网上政务服务能力</p>
          <span>异常</span>
        </div>
        <div class="item">
          <p>政务服务事项便利度</p>
          <span>异常</span>
        </div>
        <div class="item">
          <p>政务服务满意度</p>
          <span>异常</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titles from "@/components/title";

export default {
  components: {titles},
  name: "yujing",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.yujing {

}

.title1 {
  font-size: 48px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #39F9FF;
  height: 100px;
  @include flex_start_center();

}

.list {
  .item {
    height: 110px;
    @include flex_between_center();

    p {
      font-size: 48px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    span {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #E36C3D;
      width: 139px;
      height: 62px;
      border: 2px solid #C56140;
      border-radius: 10px;
      @include flex_center_center();
    }
  }
}
</style>
